import { getCookie } from '@/utils/cookie'
import Url from '@mc/mc-utils/js/url/url'
import { miniProgramEnv } from '@/defines/environment'

const getFromUrl = () => {
  const url = new Url(window.location.href)
  const { city_id: cityId } = url.parseQuerystring()
  return cityId
}

export const getCityId = userInfo => {
  if (userInfo.cityId) {
    return userInfo.cityId
  } else if (miniProgramEnv.isMiniProgram) {
    return getFromUrl()
  } else {
    return getCookie('mc_loguser_city')
  }
}
